import slugify from 'slugify';

export const sluggy = (string) => slugify(string, { remove: /[*+~,.()'"!:@]/g });
